import { InstituteDetails, User } from '@admin/api/apiTypes';
import React from 'react';
import { PassportTable, PassportTableFilters, supervisorScopedFilters } from './typedPassportTable';

interface YourPeopleWidgetProps {
  user: User | null;
  institute?: InstituteDetails | null;
  filters?: PassportTableFilters | null;
  title?: string;
  showExportButton?: boolean;
}

const YourPeopleWidget = ({
  user,
  institute,
  filters = null,
  title = 'Your People',
  showExportButton = true
}: YourPeopleWidgetProps) => {
  const combinedFilters = React.useMemo(
    () => supervisorScopedFilters(filters, user),
    [user, filters]
  );

  return (
    <PassportTable
      institute={institute}
      title={title}
      filters={combinedFilters}
      showExportButton={showExportButton}
      />
  );
};

export default YourPeopleWidget;
